var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-skeleton-loader',{attrs:{"elevation":"2","type":"list-item-avatar, card-heading","loading":_vm.loading}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }